var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendMessage = function SvgSendMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M7.75 10.25 16.5 1.5m-8.644 9.024 2.19 5.631c.193.496.29.744.429.817.12.063.264.063.384 0 .14-.072.236-.32.43-.816L16.78 2.083c.174-.448.262-.672.214-.815a.417.417 0 0 0-.263-.263c-.143-.048-.367.04-.815.214L1.844 6.711c-.496.194-.744.29-.816.43a.417.417 0 0 0 0 .384c.073.14.32.236.817.429l5.631 2.19c.101.039.151.059.194.089.037.027.07.06.097.097.03.043.05.093.09.194Z"
  })));
};
export default SvgSendMessage;